import Axios from 'axios';
import {ExecutionContainer} from '../../types/model/framework/ExecutionContainer';
import {PostProcessorType} from '../../types/postprocessor/PostProcessorType';

type Request = {
  id: string;
  projectId: string;
  fileName?: string;
  postProcessorType?: PostProcessorType;
  executionContainer?: ExecutionContainer;
};

export const getPostProcessorFileUrl = ({
  projectId,
  id,
  fileName,
  postProcessorType,
  executionContainer,
}: Request) =>
  `studio/postprocessor/view/${projectId}/initial/${id}/${fileName}?type=${postProcessorType}&container=${executionContainer}`;

export async function getPostProcessorFile({
  projectId,
  id,
  fileName,
  postProcessorType,
  executionContainer,
}: Request) {
  return Axios.request<Blob>({
    method: 'GET',
    url: `${getPostProcessorFileUrl({
      projectId,
      id,
      fileName,
      postProcessorType,
      executionContainer,
    })}&cachebust=${Date.now()}`,
    responseType: 'blob',
  });
}
